/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Contact_Erasure_In_ProgressInputs */

const en_error_contact_erasure_in_progress = /** @type {(inputs: Error_Contact_Erasure_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This contact is being erased on request: it can't be changed.`)
};

/**
* | output |
* | --- |
* | "This contact is being erased on request: it can't be changed." |
*
* @param {Error_Contact_Erasure_In_ProgressInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_contact_erasure_in_progress = /** @type {((inputs?: Error_Contact_Erasure_In_ProgressInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Contact_Erasure_In_ProgressInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_contact_erasure_in_progress(inputs)
});